import * as React from 'react';
import Image from '../Image';
export default function Figure({ image: { caption, ...image }, }) {
    return (React.createElement("figure", { style: {
            margin: 0,
        } },
        React.createElement(Image, Object.assign({ className: "w-100 db" }, image)),
        caption && React.createElement("figcaption", { className: "db pa2 tc i f6" }, caption)));
}
//# sourceMappingURL=index.js.map